import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { translate, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-escalation',
  templateUrl: './escalation.component.html',
  styleUrls: ['./escalation.component.scss']
})
export class EscalationComponent implements OnInit {

  escalation:any = null;
  edit_view:string = '';
  editing = false;


  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }


  ngOnInit(): void {


    this.getEscalation();

  }

  getEscalation(){

    this.okService.get("escalation/company",[])
    .subscribe((data) => {

      this.escalation = data.body;

      //console.log(this.escalation);
    })
  }

  chooseEdit(view:string){
    //console.log(view);

    if(view != this.escalation.type){


      if(confirm(this.transloco.translate("This will reset your escalation procedure - continue?"))) {

        this.continueEdit(view);

      }

    }else{
      this.continueEdit(view);
    }
  }


  continueEdit(view:string){
    //console.log(view);
    this.editing = true;
    this.edit_view = view;

  }



  onCompleted(completed: any) {

    //console.log(completed);
    this.editing = false;
    if(completed){
      this.getEscalation();
      this.okService.setAlert(this.transloco.translate("Your escalation procedure has been updated"),"success");
    }
  }

}
